import { render, staticRenderFns } from "./checklist_info.vue?vue&type=template&id=357c698f&scoped=true&"
import script from "./checklist_info.vue?vue&type=script&lang=js&"
export * from "./checklist_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c698f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('357c698f')) {
      api.createRecord('357c698f', component.options)
    } else {
      api.reload('357c698f', component.options)
    }
    module.hot.accept("./checklist_info.vue?vue&type=template&id=357c698f&scoped=true&", function () {
      api.rerender('357c698f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_sb/scheck/tabs/checklist_info.vue"
export default component.exports